import { GlobalStyles, Stack } from '@mui/material';
import type { LoaderFunctionArgs } from '@remix-run/cloudflare';
import { Outlet, useLoaderData } from '@remix-run/react';
import illustrationPath from '@tbd/life-assets/Illustrations/LoggedOutBackground.svg';
import { COLORS } from '@tbd/life-tokens';
import {
  GlobalNavigationBar,
  BAR_HEIGHT,
} from '@tbd/lift-ui/components/GlobalNavigationBar';

export const loader = async ({ context }: LoaderFunctionArgs) => {
  return {
    hostname: context.parsedUrl.hostname,
  };
};

export default function () {
  const loaderData = useLoaderData<typeof loader>();
  return (
    <>
      <GlobalStyles
        styles={{
          body: {
            backgroundColor: COLORS.primary_100,
            overflow: 'hidden',
            backgroundImage: `url(${illustrationPath})`,
            backgroundSize: 'cover',
            backgroundPositionX: 'right',
            backgroundPositionY: 'center',
            backgroundRepeat: 'no-repeat',
          },
        }}
      />
      <Stack>
        <GlobalNavigationBar
          appName="portal"
          logoTitleLockupLink="/login"
          hostname={loaderData.hostname}
        />
        <Stack
          component="main"
          direction="row"
          sx={{
            justifyContent: {
              xs: 'center',
              md: 'flex-start',
            },

            width: '100%',
          }}
        >
          <Stack
            direction="row"
            sx={{
              flex: 1,
              justifyContent: 'center',
              alignItems: { xs: 'flex-end', md: 'center' },
              height: `calc(100dvh - ${BAR_HEIGHT})`,
              maxWidth: '600px',
              padding: { xs: 1, sm: 3, md: 8 },
              overflow: 'auto',
            }}
          >
            <Stack
              sx={{
                flex: 1,
              }}
            >
              <Outlet />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}
